export default "__VITE_ASSET__91301a28__"